<template>
<div class="px-1 pt-1">
  <div class="input-group d-print-none sticky-top mel-glass-panel p-2">
    <button class="btn btn-primary" @click="print" :disabled="itemLabelsStore.signatureItems.length === 0">
      <font-awesome-icon :icon="['fas', 'print']" />
      {{ $t('action.printEllipsis') }}
    </button>
    <RouterLink :to="{ name: 'labels-item-items' }" class="btn btn-outline-secondary">
      <font-awesome-icon :icon="['fas', 'boxes-stacked']" />
      {{ $t('action.selectEllipsis') }}
    </RouterLink>
    <RouterLink :to="{ name: 'labels-item-capture' }" class="btn btn-outline-secondary">
      <font-awesome-icon :icon="['fas', 'plus-large']" />
      {{ $t('action.captureEllipsis') }}
    </RouterLink>
    <button class="btn btn-outline-danger" @click="clearAll" :disabled="itemLabelsStore.signatureItems.length === 0">
      <font-awesome-icon :icon="['fas', 'trash']" />
      {{ $t('action.clearAll') }}
    </button>
  </div>
  <div v-if="itemLabelsStore.signatureItems.length > 0">
    <LabelsPrintComponent :items="itemLabelsStore.signatureItems" :is-prefiltered="true" :can-remove="true" @remove="(signatureItem: IItemWithSignatureRaw) => remove(signatureItem)" />
  </div>
  <div v-else>
    <span>{{ $t('error.noData') }}</span>
  </div>
</div>
</template>

<script setup lang="ts">
import LabelsPrintComponent from "@/components/labels/LabelsPrintComponent.vue";
import IItemWithSignatureRaw from "@/models/IItemWithSignatureRaw";
import { useItemLabelsStore } from "@/stores";

const itemLabelsStore = useItemLabelsStore();

const print = () => {
  window.print();
};
const clearAll = () => {
  itemLabelsStore.clearSignatureItems();
};
const remove = (signatureItem: IItemWithSignatureRaw) => {
  itemLabelsStore.removeSignatureItem(signatureItem);
}
</script>
